import CustomersDialog from "./customersDialog/CustomersDialog";

export default CustomersDialog;
